
import React from 'react';
import ArrowLeftOutline from '../../element/icons/arrow-left-outline';

import { useStore } from '../../hooks';
import { CLOSING_REASONS } from '../../utils/constants';
import TopbarIconButton from './TopbarIconButton';

const BackButton = () => {
  const {
    t,
    haveNotSavedChanges,
    config: { onClose },
  } = useStore();

  if (typeof onClose !== 'function') {
    return null;
  }

  const closeWithReason = () => {
    onClose(CLOSING_REASONS.CLOSE_BUTTON, haveNotSavedChanges);
  };

  return (
    <TopbarIconButton
      className="respark_topbar-btn--back"
      title={t('back')}
      onClick={closeWithReason}
    >
      <ArrowLeftOutline size={16} />
    </TopbarIconButton>
  );
};

export default BackButton;
